var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("ul", [
        _c("div", { staticClass: "accordion-item accordionForm" }, [
          _c(
            "a",
            {
              staticClass: "item-content item-link",
              attrs: { href: "#" },
              on: {
                click: function ($event) {
                  return _vm.rotateChevron($event)
                },
              },
            },
            [
              _c("div", { staticClass: "item-inner" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "form-group row justify-content-start styleGeneral",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "item-title createInvoiceBand col-sm-auto",
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.$t("common.formsSubTitle.gnrl")) +
                            "\n                "
                        ),
                        _c("i", { staticClass: "f7-icons formChevron" }, [
                          _vm._v("chevron_right"),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "accordion-item-content" }, [
            _c(
              "div",
              { staticClass: "form-group d-flex justify-content-between" },
              [
                _c("label", { staticClass: "col-form-label" }, [
                  _vm._v(_vm._s(_vm.$t("settings.gnrt_bnk_trnsfr_ordr"))),
                ]),
                _vm._v(" "),
                _c(
                  "label",
                  { staticClass: "label-switch", class: _vm.sliderColorClass },
                  [
                    _c("input", {
                      staticClass: "checkboxPain001",
                      attrs: {
                        type: "checkbox",
                        disabled: _vm.canSwichPain001(),
                      },
                      domProps: {
                        checked: _vm.settings.pain001 === "1",
                        value: _vm.settings.pain001,
                      },
                      on: { change: _vm.switchPain001 },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "checkbox" }),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-group d-flex justify-content-between" },
              [
                _c("label", { staticClass: "col-form-label labelCheckbox" }, [
                  _vm._v(_vm._s(_vm.$t("settings.gnrt_instnt_pymnt"))),
                ]),
                _vm._v(" "),
                _c(
                  "label",
                  { staticClass: "label-switch", class: _vm.sliderColorClass },
                  [
                    _c("input", {
                      staticClass: "checkboxPacs008",
                      attrs: {
                        type: "checkbox",
                        disabled: _vm.canSwitchPacs008(),
                      },
                      domProps: {
                        checked: _vm.settings.pacs008 === "1",
                        value: _vm.settings.pacs008,
                      },
                      on: { change: _vm.changeSwitchPacs008 },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "checkbox" }),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-group d-flex justify-content-between" },
              [
                _c("label", { staticClass: "col-form-label" }, [
                  _vm._v(
                    _vm._s(_vm.$t("directPayments.dir_pymnt_decision_form"))
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "label",
                  { staticClass: "label-switch", class: _vm.sliderColorClass },
                  [
                    _c("input", {
                      staticClass: "checkboxDecisionCreancier",
                      attrs: {
                        type: "checkbox",
                        disabled: _vm.canSwitchCreditorDecision(),
                      },
                      domProps: {
                        checked: _vm.settings.decision_creancier === "1",
                        value: _vm.settings.decision_creancier,
                      },
                      on: { change: _vm.changeSwitchDecisionCreancier },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "checkbox" }),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-group d-flex justify-content-between" },
              [
                _c("label", { staticClass: "col-form-label" }, [
                  _vm._v(_vm._s(_vm.$t("settings.activate_OCR"))),
                ]),
                _vm._v(" "),
                _c(
                  "label",
                  { staticClass: "label-switch", class: _vm.sliderColorClass },
                  [
                    _c("input", {
                      staticClass: "checkboxOcrActivation",
                      attrs: {
                        type: "checkbox",
                        disabled: _vm.canSwitchOcrActivation(),
                      },
                      domProps: {
                        checked: _vm.settings.ocrActivation === "1",
                        value: _vm.settings.ocrActivation,
                      },
                      on: { change: _vm.changeSwitchOcrActivation },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "checkbox" }),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-group d-flex justify-content-between" },
              [
                _c("label", { staticClass: "col-form-label" }, [
                  _vm._v(_vm._s(_vm.$t("settings.ntfy_rcvr_by_eml"))),
                ]),
                _vm._v(" "),
                _c(
                  "label",
                  { staticClass: "label-switch", class: _vm.sliderColorClass },
                  [
                    _c("input", {
                      staticClass: "checkboxEmailRcv",
                      attrs: {
                        type: "checkbox",
                        disabled: _vm.canSwitchEmailRcv(),
                      },
                      domProps: {
                        checked: _vm.settings.emailForRcv === "1",
                        value: _vm.settings.emailForRcv,
                      },
                      on: { change: _vm.switchEmailRcv },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "checkbox" }),
                  ]
                ),
              ]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("ul", [
        _c("div", { staticClass: "accordion-item accordionForm" }, [
          _c(
            "a",
            {
              staticClass: "item-content item-link",
              attrs: { href: "#" },
              on: {
                click: function ($event) {
                  return _vm.rotateChevron($event)
                },
              },
            },
            [
              _c("div", { staticClass: "item-inner" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "form-group row justify-content-start styleGeneral",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "item-title createInvoiceBand col-sm-auto",
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.$t("common.formsSubTitle.othr")) +
                            "\n                "
                        ),
                        _c("i", { staticClass: "f7-icons formChevron" }, [
                          _vm._v("chevron_right"),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "accordion-item-content" }, [
            _c(
              "div",
              { staticClass: "form-group d-flex justify-content-between" },
              [
                _c("label", { staticClass: "col-form-label" }, [
                  _vm._v(_vm._s(_vm.$t("settings.allwys_accpt_dir_pymnts"))),
                ]),
                _vm._v(" "),
                _c(
                  "label",
                  { staticClass: "label-switch", class: _vm.sliderColorClass },
                  [
                    _c("input", {
                      staticClass: "checkboxAutoAcceptPayment",
                      attrs: {
                        type: "checkbox",
                        disabled: _vm.canSwitchAutoAcceptPayment(),
                      },
                      domProps: {
                        checked: _vm.settings.auto_accept_payment === "1",
                        value: _vm.settings.auto_accept_payment,
                      },
                      on: { change: _vm.changeSwitchAutoAcceptPayment },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "checkbox" }),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("label", { staticClass: "col-form-label" }, [
                _vm._v(_vm._s(_vm.$t("settings.hghst_amnt"))),
              ]),
              _vm._v(" "),
              _c("div", { staticStyle: { "text-align": "right" } }, [
                _vm._v(_vm._s(_vm.settings.max_amount)),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.settings.max_amount,
                    expression: "settings.max_amount",
                  },
                ],
                staticClass: "range-slider-streammind",
                class: _vm.sliderColorClass,
                attrs: {
                  type: "range",
                  min: "0",
                  max: "150000",
                  value: "0",
                  step: "500",
                  disabled: _vm.canSwitchMaxAmount(),
                },
                domProps: { value: _vm.settings.max_amount },
                on: {
                  __r: function ($event) {
                    return _vm.$set(
                      _vm.settings,
                      "max_amount",
                      $event.target.value
                    )
                  },
                },
              }),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "form-group justify-content-end mr-5" },
        [
          _c(
            "b-col",
            { attrs: { sm: "3" } },
            [
              _c(
                "b-button",
                {
                  attrs: { variant: "primary", size: "lg" },
                  on: { click: _vm.changeApplicationSettings },
                },
                [_c("span", [_vm._v(_vm._s(_vm.$t("common.sve")))])]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }